// ============================================================
// BOOKING TABLE COMPONENT
// ============================================================

import { Filter } from 'lucide-react';
import { Booking } from '../../types/booking.types';
import { BookingTableRow } from './BookingTableRow';

interface BookingTableProps {
  bookings: Booking[];
  onBookingClick: (booking: Booking) => void;
  onResetFilters: () => void;
}

export function BookingTable({ bookings, onBookingClick, onResetFilters }: BookingTableProps) {
  const hasNoResults = bookings.length === 0;

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left">
          <TableHeader />
          <tbody className="divide-y divide-slate-100 text-slate-700">
            {hasNoResults ? (
              <EmptyState onResetFilters={onResetFilters} />
            ) : (
              bookings.map((booking) => (
                <BookingTableRow key={booking.id} booking={booking} onRowClick={onBookingClick} />
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function TableHeader() {
  return (
    <thead className="bg-[#f8fafc] text-slate-500 border-b border-slate-200 font-medium whitespace-nowrap">
      <tr>
        <th className="px-5 py-3.5 pl-6">Référence</th>
        <th className="px-5 py-3.5">Client & Date</th>
        <th className="px-5 py-3.5">Espace & Dates</th>
        <th className="px-5 py-3.5">Prix HT</th>
        <th className="px-5 py-3.5">Paiement</th>
        <th className="px-5 py-3.5">Statut</th>
        <th className="px-5 py-3.5 pr-6 text-right">Actions</th>
      </tr>
    </thead>
  );
}

function EmptyState({ onResetFilters }: { onResetFilters: () => void }) {
  return (
    <tr>
      <td colSpan={7} className="px-5 py-16 text-center text-slate-400">
        <div className="flex flex-col items-center gap-2">
          <Filter className="w-8 h-8 opacity-20" />
          <p>Aucune réservation ne correspond à vos filtres.</p>
          <button onClick={onResetFilters} className="mt-2 text-primary font-medium hover:underline text-sm">
            Effacer les filtres
          </button>
        </div>
      </td>
    </tr>
  );
}
